import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './SidebarNew';
import Header from './HeaderNew';
import ConnectivityBanner from '../common/ConnectivityBanner';
import RouteErrorBoundary from '../ui/RouteErrorBoundary';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="flex h-screen overflow-hidden" data-density="comfortable" style={{ backgroundColor: 'var(--color-surface-sunken)' }}>
      {/* Skip to content (WCAG 2.1 A) */}
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content area */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <ConnectivityBanner />
        <main
          id="main-content"
          tabIndex={-1}
          className="flex-1 overflow-y-auto pt-4 md:pt-6 px-4 md:px-6 focus:outline-none"
        >
          {/* PT-41.1 (2026-07-27): single app-wide max content width.
              1440px keeps the UI from sprawling on 1680/1920/2560 viewports.
              `mx-auto` centres the constrained content; the outer <main>
              stays edge-to-edge so scrolling and the sunken surface
              backdrop still fill the viewport. Token defined in
              `tokens.css` (`--layout-content-max`). */}
          {/* R18/AM-1 follow-up (2026-07-31 evening): <main>'s bottom padding
              moved to the inner content wrapper (`pb-4 md:pb-6` below).
              Rationale: <main> is the scroll container, and `position: sticky`
              inside routes resolves against <main>'s padding-box. If <main>
              has padding-bottom, sticky bottom-0 pins ABOVE the viewport by
              that amount — causing a visible inset even when the author
              added -mx/-mb bleed correction on the sticky element (see the
              R18 AM-1 case in CALIBRATION_LOG_2026-07-31-VIS §C-7).
              Moving pb-* to the wrapper means: (a) <main>'s padding-box
              bottom == viewport bottom, so sticky footers render flush;
              (b) ordinary routes still get 24px bottom breathing room via
              the wrapper's pb-*; (c) sticky-footer routes (R&S) already opt
              out via `-mb-4 md:-mb-6` on their root wrapper, which now
              cleanly negates the WRAPPER's pb-* to reach the viewport edge.
              Top + horizontal padding stay on <main> so `sticky top-*`
              elements inside routes keep their current pin positions. */}
          <div
            className="mx-auto w-full pb-4 md:pb-6"
            style={{ maxWidth: 'var(--layout-content-max)' }}
          >
            <RouteErrorBoundary resetKey={location.pathname}>
              <Outlet />
            </RouteErrorBoundary>
          </div>
        </main>
      </div>
    </div>
  );
}
